<template>
  <div class="classify-details">
    <nav-bar title="分类详情" left-text show-home></nav-bar>
    <div class="classify-details-wrapper" v-show="productList.length">
      <div class="title">
        <button>全部商品</button>
        <button class="price-sort" @click="sortProduct">
          <span>价格</span>
          <div class="triangle">
            <a href="javascript:;" class="up-triangle" :class="sortChecked === 0 ? 'checked' : '' "></a>
            <a
              href="javascript:;"
              class="down-triangle"
              :class="sortChecked === 1 ? 'checked' : '' "
            ></a>
          </div>
        </button>
      </div>
      <div class="classify-details-list">
        <list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">
          <div class="product-list">
            <product-double :sku-list="productList"></product-double>
          </div>
        </list>
      </div>
    </div>
    <div class="no-data" v-show="noData && !productList.length">暂无商品</div>
  </div>
</template>

<script>
import NavBar from '../components/NavBar'
import ProductDouble from '../components/ProductDoubleEach'
import { List } from 'vant'
let flag = false
export default {
  name: 'classify',
  components: {
    NavBar,
    ProductDouble,
    List
  },
  data () {
    return {
      pageNum: 1,
      productList: [],
      count: 0,
      loading: false,
      finished: false,
      noData: false,
      sortChecked: 0
    }
  },
  computed: {
    noMore () {
      return this.count >= this.productList.length
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  created () {
    this.$toast.loading('加载中...')
    this.classfyId = this.$route.query.id
    this.getClassifyProductList(this.classfyId).then(() => {
      this.$toast.clear()
    })
  },
  methods: {
    sortProduct () {
      this.sortChecked = !this.sortChecked - 0
      this.pageNum = 1
      this.finished = false
      this.productList = []
      window.scrollTo(0, 0)
      this.getClassifyProductList(this.classfyId, this.pageNum)
    },
    async getClassifyProductList (id, pageNum) {
      const res = await this.$axios.get(
        `/api/goods/categoryItems/${id}/${pageNum || 1}/${this.sortChecked}`
      )
      if (res.status === 200) {
        const { code, count, msg, data } = res.data
        if (code === 0) {
          this.count = count
          if (pageNum === 1) {
            this.productList = data
          } else {
            this.productList = [...this.productList, ...data]
          }
        } else if (code === 9006) {
          if (this.pageNum === 1) {
            this.noData = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    },
    loadMore () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getClassifyProductList(this.classfyId, ++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 200)
    }
  },
  activated () {
    if (this.classfyId !== this.$route.query.id) {
      this.classfyId = this.$route.query.id
      this.pageNum = 1
      this.noData = false
      this.finished = false
      this.productList = []
      this.$toast.loading('加载中...')
      this.getClassifyProductList(this.classfyId, this.pageNum).then(() => {
        this.$toast.clear()
      })
    }
  }
  // deactivated () {
  //   console.log(2222)
  // }
}
</script>

<style lang="less" scoped>
.classify-details {
}
.navbar {
  .home {
    width: 0.58rem;
    height: 0.58rem;
  }
}
.classify-details-wrapper {
  padding-top: 0.88rem;
  .title {
    position: fixed;
    top: 0.88rem;
    left: 0;
    right: 0;
    padding: 0 0.2rem;
    height: 0.8rem;
    .flex-between;
    font-size: @fz24;
    color: @base;
    background-color: #fff;
    .price-sort {
      display: flex;
      align-items: center;
      height: 100%;
      .triangle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        .up-triangle,
        .down-triangle {
          margin-left: 0.1rem;
          border-width: 0.1rem;
          border-style: solid;
          border-color: #979797 transparent transparent transparent;
        }
        .up-triangle {
          transform: rotate(180deg);
        }
        .down-triangle {
          margin-top: 0.05rem;
          /*顺时针旋转90°*/
        }
      }
      .triangle a.checked {
        border-color: #ff2851 transparent transparent transparent;
      }
    }
  }
  .product-list {
    padding: 0 0.2rem 0.2rem;
    // .flex-between-wrap;
  }
}
.no-data {
  font-size: @fz32;
  text-align: center;
  padding: 2rem 0.5rem;
}
</style>
